exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hover-1-wrapper[data-v-429e7296]{width:210px;padding-bottom:10px}", ""]);

// exports
